"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSsoContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const filterCountryByCountryCode_1 = require("../dataLayer/filters/filterCountryByCountryCode");
const auth_1 = __importDefault(require("../auth"));
const constants_1 = require("../constants");
const localStorageUtility_1 = __importDefault(require("../hooks/localStorageUtility"));
const GtmData_1 = require("../GTMs/GtmData");
const AppContext = (0, react_1.createContext)({});
function useSsoContext() {
    return (0, react_1.useContext)(AppContext);
}
exports.useSsoContext = useSsoContext;
const ssoReducer = (state, action) => {
    if (action === null || action === void 0 ? void 0 : action.hasOwnProperty("screenType")) {
        const screenIndex = state.screensFlow.indexOf(action.screenType);
        if (screenIndex !== -1) {
            state.screensFlow = state.screensFlow.slice(0, screenIndex + 1);
        }
        else {
            state.screensFlow.push(action.screenType);
        }
    }
    return Object.assign(Object.assign({}, state), action);
};
const { getItem: getLocalStorage } = (0, localStorageUtility_1.default)();
const AppContextProvider = ({ children, countries, ssoConfigurations, otpData, }) => {
    const screenType = auth_1.default.getInstance().screenType;
    const phoneCode = (0, filterCountryByCountryCode_1.getCountryByCountryAbbreviation)(countries, auth_1.default.getInstance().country);
    const memberData = auth_1.default.getInstance().memberData;
    (0, GtmData_1.useGtmDefaultData)();
    const initialState = {
        phone: getLocalStorage(constants_1.LocalStorageConstants.PHONE_NUMBER) || "",
        flow_type: "",
        countries,
        country: (0, filterCountryByCountryCode_1.filterCountryByCountryCode)(countries, phoneCode.phone_code),
        screenType: screenType,
        successScreen: { title: "", description: "", withAddPost: true },
        confirmationScreen: {
            title: "",
            description: "",
            callBack: () => { },
        },
        errorScreen: {
            title: "",
            description: "",
            cbTranslation: "",
            callBack: () => { },
        },
        verificationType: "whatsApp",
        ssoConfigurations,
        screensFlow: [screenType],
        otpData,
        memberData: memberData
    };
    const [flowState, dispatch] = (0, react_1.useReducer)(ssoReducer, initialState);
    (0, react_1.useEffect)(() => {
        if (ssoConfigurations) {
            dispatch({ ssoConfigurations });
        }
    }, [ssoConfigurations]);
    return ((0, jsx_runtime_1.jsx)(AppContext.Provider, Object.assign({ value: { flowState, dispatch } }, { children: children })));
};
exports.default = AppContextProvider;
